<template>
  <div class="flex-col page">
    <div class="flex-row section_1">
      <div class="flex-col items-center group">
        <span @click="text_8OnClick">行言君商城</span>
        <div class="section_2"></div>
      </div>
      <span @click="textOnClick" class="text_1">便签</span>
      <span @click="text_1OnClick" class="text_2">办公文具</span>
      <span @click="text_2OnClick" class="text_3">文件收纳</span>
      <span @click="text_3OnClick" class="text_4">学生文具</span>
      <span @click="text_4OnClick" class="text_5">计算器</span>
      <span @click="text_5OnClick" class="text_6">画具画材</span>
      <span @click="text_6OnClick" class="text_7">文方四宝</span>
      <div class="flex-row section_3">
        <div class="flex-row group_1">
          <img src="../assets/16488068565369237271.png" class="image" />
          <span class="text_8">输入商品名称</span>
        </div>
        <div class="flex-col items-center text-wrapper">
          <span>搜索</span>
        </div>
      </div>
      <span @click="text_7OnClick" class="text_10">开通会员</span>
    </div>
    <div class="flex-col group_2">
      <div class="group_3">
        <img src="../assets/16488068565354858544.png" class="image_1" />
        <img src="../images/2d70be86c03939b98f8efff3c5332aa0.png" class="image_2" />
        <div class="flex-row group_4">
          <img src="../assets/16488691326399816184.png" class="image_3" />
          <img src="../images/a8213186285c29531b3651fb914a4a39.png" class="image_4" />
          <img src="../images/3877f1c6fa62dbe345356924acc1948f.png" class="image_5" />
          <div class="flex-col section_4">
            <div class="justify-between group_5">
              <span class="text_11">陈光文具K35/0.35黑色中性笔 按动签字笔碳素笔水笔（10支+10支芯）刷题套装</span>
              <span class="text_12">200君币</span>
            </div>
            <div class="divider flex-row">
              <span>数量</span>
              <span class="text_14">1件</span>
            </div>
            <div class="section_5"></div>
            <div class="divider flex-row">
              <span>地址</span>
              <span class="text_14">陕西省西安市长安区</span>
            </div>
            <div class="flex-row group_6">
              <div class="flex-row group_7">
                <span>服务</span>
                <span class="text_19">7天无理由退化</span>
              </div>
              <div class="flex-col items-center text-wrapper_1">
                <span>立即购买</span>
              </div>
            </div>
          </div>
          <div class="flex-col section_6">
            <img src="../assets/c02ba79eab197a62bb9c3bf48ebe6082.png" class="image_6" />
            <img src="../assets/16488068565360356644.png" class="image_7" />
            <span class="text_21">兑换成功</span>
            <div class="justify-center group_8">
              <span class="text_22">金额</span>
              <span>200君币</span>
            </div>
            <div class="flex-row group_9">
              <span>订单编号</span>
              <span class="text_25">4589245634566</span>
            </div>
            <div class="justify-evenly group_10">
              <span class="text_26">收件人</span>
              <span class="text_27">鲁瑶婉</span>
              <span class="text_28">13112342304</span>
            </div>
            <div class="justify-evenly group_11">
              <span>收货地址</span>
              <span>陕西省西安市长安区</span>
            </div>
            <div class="justify-evenly group_12">
              <span class="text_31">下单时间</span>
              <span class="text_32">2021-06-14</span>
              <span class="text_33">10:10:21</span>
            </div>
            <div class="flex-row group_13">
             <!-- <div @click="view_28OnClick" class="flex-col items-center text-wrapper_2">
                <span>查看订单</span>
              </div> -->
              <div @click="view_29OnClick" class="flex-col items-center text-wrapper_3">
                <span>回到首页</span>
              </div>
            </div>
          </div>
        </div>
        <div class="section_7"></div>
        <img src="../images/c91d1cc1b7af4d17c41c873c694a21ce.png" class="image_8" />
        <img src="../assets/16488068565354858544.png" class="image_9" />
      </div>
      <div class="justify-between section_8">
        <div class="flex-row group_14">
          <span>产品介绍</span>
          <span class="text_37">规格与包装</span>
          <span class="text_38">售后保障</span>
          <span class="text_39">商品评价</span>
        </div>
        <span class="text_40">加入购物车</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {
      text_8OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      textOnClick() {
        this.$router.push({ name: 'wenju' });
      },
      text_1OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      text_2OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      text_3OnClick() {
        this.$router.push({ name: 'index' });
      },
      text_4OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      text_5OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      text_6OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      text_7OnClick() {
        this.$router.push({ name: 'Page_huiyuankaitongyemianbeifen_2' });
      },
      view_28OnClick() {
        this.$router.push({ name: 'wenju' });
      },
      view_29OnClick() {
        this.$router.push({ name: 'wenju' });
      },
    },
  };
</script>

<style scoped lang="css">
  .divider {
    color: rgb(8, 4, 23);
    font-size: 0.19rem;
    line-height: 0.25rem;
    white-space: nowrap;
    padding: 0 0.13rem;
  }
  .text_14 {
    margin-left: 0.25rem;
  }
  .page {
    background-color: #f2f2f4;
    width: 100%;
    overflow-y: auto;
    height: 100%;
  }
  .section_1 {
    padding: 0.16rem 0 0.16rem;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0.011rem 0px 0px rgb(245, 86, 86);
    position: relative;
  }
  .group_2 {
    padding: 0 4.91rem 0.94rem 4.91rem;
  }
  .group {
    margin-left: 2.94rem;
    padding-bottom: 0.063rem;
    color: rgb(255, 73, 73);
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.31rem;
    white-space: nowrap;
    position: relative;
  }
  .text_1 {
    margin-left: 0.47rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_2 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_3 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_4 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_5 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_6 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .text_7 {
    margin-left: 0.53rem;
    margin-bottom: 0.094rem;
    color: rgb(67, 65, 65);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
  }
  .section_3 {
    margin-left: 1.13rem;
    padding-left: 0.13rem;
    background-color: rgb(255, 255, 255);
    border-radius: 0.031rem;
    height: 0.41rem;
    border: solid 0.063rem rgb(245, 86, 86);
  }
  .text_10 {
    margin-left: 0.28rem;
    color: rgb(245, 86, 86);
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.31rem;
    white-space: nowrap;
  }
  .group_3 {
    height: 10.03rem;
    border-bottom: solid 0.063rem rgb(216, 216, 216);
    position: relative;
  }
  .section_8 {
    margin-top: 0.38rem;
    padding: 0.19rem 0.25rem;
    background-color: rgb(249, 249, 249);
    box-shadow: 0px 0.011rem 0px 0px rgb(245, 86, 86);
  }
  .section_2 {
    background-color: rgb(255, 73, 73);
    width: 0.28rem;
    height: 0.063rem;
    position: absolute;
    left: 0.094rem;
    bottom: 0;
  }
  .group_1 {
    color: rgb(125, 122, 133);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text-wrapper {
    margin-left: 0.84rem;
    color: rgb(255, 255, 255);
    font-size: 0.19rem;
    font-weight: 500;
    line-height: 0.25rem;
    white-space: nowrap;
    background-color: rgb(245, 86, 86);
    border-radius: 0.031rem;
    width: 0.78rem;
    height: 0.41rem;
    border: solid 0.063rem rgb(245, 86, 86);
  }
  .image_1 {
    width: 0.81rem;
    height: 1.5rem;
    position: absolute;
    left: 0;
    bottom: 2.84rem;
  }
  .image_2 {
    width: 2.16rem;
    height: 1.5rem;
    position: absolute;
    left: 0.81rem;
    bottom: 2.84rem;
  }
  .group_4 {
    height: 9.44rem;
    position: absolute;
    left: 0;
    right: 0px;
    top: 0;
  }
  .section_7 {
    background-color: rgb(212, 212, 212);
    width: 0.063rem;
    height: 1.5rem;
    position: absolute;
    right: 2.91rem;
    bottom: 2.84rem;
  }
  .image_8 {
    width: 2.16rem;
    height: 1.5rem;
    position: absolute;
    right: 0.81rem;
    bottom: 2.84rem;
  }
  .image_9 {
    width: 0.81rem;
    height: 1.5rem;
    position: absolute;
    right: 0px;
    bottom: 2.84rem;
  }
  .group_14 {
    color: rgb(44, 40, 57);
    font-size: 0.22rem;
    line-height: 0.22rem;
    white-space: nowrap;
    width: 5.16rem;
  }
  .text_40 {
    color: rgb(245, 86, 86);
    font-size: 0.22rem;
    font-weight: 500;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .image {
    width: 0.38rem;
    height: 0.28rem;
  }
  .text_8 {
    margin-left: 0.13rem;
  }
  .image_3 {
    width: 2.16rem;
    height: 1.5rem;
    position: absolute;
    left: 2.97rem;
    bottom: 2.31rem;
  }
  .image_4 {
    width: 2.16rem;
    height: 1.5rem;
    position: absolute;
    right: 2.97rem;
    bottom: 2.31rem;
  }
  .image_5 {
    background-color: rgb(255, 255, 255);
    width: 10.22rem;
    height: 5.63rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
  }
  .section_4 {
    background-color: rgb(249, 249, 249);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .section_6 {
    padding: 0.5rem 0.53rem 0 0.66rem;
    background-color: rgb(245, 245, 245);
    box-shadow: 0px 0.021rem 0.042rem 0px rgba(0, 0, 0, 0.19);
    border-radius: 0.063rem;
    width: 4.09rem;
    position: absolute;
    bottom: 0.22rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .text_37 {
    margin-left: 0.53rem;
  }
  .text_38 {
    margin-left: 0.53rem;
  }
  .text_39 {
    margin-left: 0.53rem;
  }
  .group_5 {
    margin-left: 0.13rem;
    margin-right: 0.13rem;
    padding: 0.22rem 0 0.13rem;
  }
  .section_5 {
    margin-top: 0.094rem;
    background-color: rgb(216, 216, 216);
    width: 6.69rem;
    height: 0.063rem;
  }
  .group_6 {
    padding-bottom: 0.13rem;
    height: 0.59rem;
    position: relative;
  }
  .image_6 {
    width: 0.16rem;
    height: 0.16rem;
    position: absolute;
    right: 0.19rem;
    top: 0.19rem;
  }
  .image_7 {
    align-self: center;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    position: relative;
  }
  .text_21 {
    margin-top: 0.16rem;
    align-self: center;
    color: rgb(8, 4, 23);
    font-size: 0.19rem;
    line-height: 0.25rem;
    white-space: nowrap;
    position: relative;
  }
  .group_8 {
    margin-top: 0.41rem;
    padding: 0 0.56rem;
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    position: relative;
  }
  .group_9 {
    padding: 0.13rem 0.22rem 0.13rem;
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    position: relative;
  }
  .group_10 {
    padding: 0 0.41rem 0.094rem;
    position: relative;
  }
  .group_11 {
    padding: 0 0.22rem 0.13rem;
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    position: relative;
  }
  .group_12 {
    padding: 0 0.22rem;
    position: relative;
  }
  .group_13 {
    padding: 0.66rem 0 0.47rem;
    position: relative;
  }
  .text_11 {
    color: rgb(8, 4, 23);
    font-size: 0.25rem;
    font-weight: 500;
    line-height: 0.31rem;
    text-align: left;
    width: 7.13rem;
  }
  .text_12 {
    color: rgb(245, 86, 86);
    font-size: 0.25rem;
    font-weight: 600;
    line-height: 0.34rem;
    white-space: nowrap;
  }
  .group_7 {
    padding: 0.16rem 0.13rem 0;
    color: rgb(8, 4, 23);
    font-size: 0.19rem;
    line-height: 0.25rem;
    white-space: nowrap;
    width: 6.69rem;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-top: solid 0.063rem rgb(216, 216, 216);
  }
  .text-wrapper_1 {
    padding: 0.13rem 0;
    color: rgb(255, 255, 255);
    font-size: 0.22rem;
    line-height: 0.22rem;
    white-space: nowrap;
    background-color: rgb(245, 86, 86);
    width: 1.38rem;
    position: absolute;
    right: 0.13rem;
    top: 50%;
    transform: translateY(-50%);
  }
  .text_22 {
    position: absolute;
    left: 0.56rem;
    top: 50%;
    transform: translateY(-50%);
  }
  .text_25 {
    margin-left: 0.19rem;
  }
  .text_26 {
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_27 {
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_28 {
    color: rgb(8, 4, 23);
    font-size: 0.13rem;
    line-height: 0.19rem;
    white-space: nowrap;
  }
  .text_31 {
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_32 {
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text_33 {
    color: rgb(8, 4, 23);
    font-size: 0.13rem;
    line-height: 0.19rem;
    white-space: nowrap;
  }
  .text-wrapper_2 {
    flex: 1 1 1.34rem;
    color: rgb(8, 4, 23);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    background-color: rgb(255, 255, 255);
    border-radius: 0.031rem;
    width: 1.34rem;
    height: 0.41rem;
    border: solid 0.063rem rgb(86, 96, 245);
  }
  .text-wrapper_3 {
    margin-left: 0.19rem;
    padding: 0.094rem 0;
    flex: 1 1 1.34rem;
    color: rgb(255, 255, 255);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    background-color: rgb(86, 96, 245);
    border-radius: 0.031rem;
    width: 1.34rem;
    height: 0.41rem;
  }
  .text_19 {
    margin-left: 0.25rem;
  }
</style>